import { TYPES } from "./types";

export const removeResolvers = (props) => {
    const newProps = {...props};

    for (const key in props) {
        if (TYPES.includes(key)) {
            delete newProps[key];
        }
    }

    return newProps;
}